// UsefulLifeMaster/index.js
import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { Button, Col, Modal, Row } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";

import kbn from "../../../api/backend/kbn";
import { UseFulLifeApi } from "../../../api/backend/usefulLifeMaster";
import Loading from "../../../component/Desktop/loading/loading";
import TitlePage from "../../../component/Desktop/titlePage";
import FooterPage from "../../../component/footer/footerPage";
import Overlay from "../../../component/Overlay/Overlay";
import SplitComponent from "../../../component/split-component/SplitComponent";
import {
  COMMON_CONSTANT,
  KEY,
  lang,
  MODE_SCREEN,
} from "../../../constants/common.const";
import {
  handleCatchError,
  showMessage,
  statusRes,
} from "../../../constants/utils";
import classDdl from "../../../models/control/dropdownlist";
import classGrid from "../../../models/control/grid";
import classText from "../../../models/control/text";
import { isEmptyData } from "../../../utils/helper";
import ListUsefulLifeMaster from "./list";
import ViewUsefulLifeMaster from "./view";
import { useDispatch, useSelector } from "react-redux";
import { setWidthModalColTable } from "../../../redux/sideBar";
import rolesConst from "../../../routers/roles/roles.const";
const originData = {
  equipmentCategoryCode: new classText(""),
  equipmentCategoryName: new classText(""),
  mainCategoryCode: new classText(""),
  mainCategoryName: new classText(""),
  subCategoryCode: new classText(""),
  subCategoryName: new classText(""),
  smallCategoryCode: new classText(""),
  smallCategoryName: new classText(""),
  subDivisionCategoryCode: new classText(""),
  subDivisionCategoryName: new classText(""),
  materialName: new classText(""), //
  standardUsefulLife: new classText(""),
  targetUsefulLife: new classText(""),
  displayOrder: new classText(""),
  id: new classText(""),
  categoryId: new classText(""),
};
const originDataInstance = () => JSON.parse(JSON.stringify(originData));

const UsefulLifeMaster = () => {
  const [dataSource, setDataSource] = useState(new classGrid());
  const [data, setData] = useState(originDataInstance());
  const [mode, setMode] = useState(MODE_SCREEN.VIEW);
  const [currentNode, setCurrentNode] = useState(null);
  const [dataSearch, setDataSearch] = useState({
    equipmentCategory: new classDdl(""),
  });
  const [firstNodeFilter, setFirstNodeFilter] = useState();

  const [loading, setLoading] = useState(false);
  const inputRefs = useRef({});
  const [isFillData, setIsFillData] = useState(false);

  const [triggerWidth, setTriggerWidth] = useState(false);
  const { collapsed } = useSelector((state) => state.sideBar);
  const [maxSize, setMaxSize] = useState(window.innerWidth - 400);
 
  const [editData, setEditData] = useState(null);
  const [disabledEdit, setDisabledEdit] = useState(false);
  const dispatch = useDispatch();

  const {roles} = useSelector(state => state.auth)
  const isLead  = roles === rolesConst.HEAD_OFFICE_ADMIN 

  const handleEdit = () => {
    setMode(MODE_SCREEN.EDIT);
    setDisabledEdit(true);
    setEditData(JSON.parse(JSON.stringify(data)));
  }

  const onCancel = () => {
    setMode(MODE_SCREEN.VIEW);
    if (!currentNode || (currentNode && isEmptyData(currentNode.id))) {
      return;
    }
    getDetailById(currentNode.id);
    setIsFillData(false);
  };
  const handleCancel = () => {
    if (isFillData) {
      Modal.confirm({
        centered: true,
        icon: <QuestionCircleOutlined />,
        title: lang.CONFIRM,
        content: COMMON_CONSTANT.BOM_C018,
        okText: lang.OK,
        cancelText: lang.CANCEL,
        onOk: onCancel,
      });
    } else {
      onCancel();
    }
  };

  const showConfirmMessage = (msg, callbackOK, callbackCancel) => {
    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      centered: true,
      title: lang.CONFIRM,
      content: msg,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onCancel: callbackCancel || (() => Modal.destroyAll()),
      onOk: callbackOK || (() => Modal.destroyAll()),
    });
  };

  const validate = () => {
    let flagError = false;
    const dataCheck = { ...data };
    let firstKey = "";

    const textFields = ["standardUsefulLife", "targetUsefulLife"];

    for (const key of textFields) {
      if (isEmptyData(dataCheck[key].value)) {
        flagError = true;
        dataCheck[key].error = true;
        if (!firstKey) firstKey = key;
      } else {
        dataCheck[key].error = false;
      }
    }

    if (
      firstKey &&
      inputRefs &&
      inputRefs.current &&
      inputRefs.current[firstKey]
    ) {
      inputRefs.current[firstKey].focus();
    }

    setData(dataCheck);
    return !flagError;
  };
  const resetData = () => {
    setData(originDataInstance());
    setCurrentNode(null);
  };
  const handleAfterAddEdit = async (currentId) => {
    setMode(MODE_SCREEN.VIEW);
    const listData = await getListUseFulLife(
      dataSearch.equipmentCategory.value,
      currentId
    );
    if (!listData || !Array.isArray(listData)) {
      resetData();
      return;
    }

    const currenUsefulLife = listData.find((i) => i.id == currentId);
    if (currenUsefulLife) {
      onSelectList(currenUsefulLife, true, true);
    }
  };

  // DELETE
  const showMessageDeleteConfirm = () => {
    // Action del
    const funcDel = async () => {
      try {
        await UseFulLifeApi.deleteUsefulLifeMaster(
          currentNode ? currentNode.useFullId : ""
        );
        showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C004, () =>
          handleAfterAddEdit(currentNode ? currentNode.id : "")
        );
      } catch (error) {
        handleCatchError(error);
      } finally {
        setLoading(false);
      }
    };

    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      title: lang.DELETE,
      content: COMMON_CONSTANT.BOM_C001,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onOk: funcDel,
      centered: true,
    });
  };
  const onSaveData = async () => {
    try {
      setLoading(true);
      const body = {
        id: data.id.value,
        machineClassification: data.equipmentCategoryCode.value,
        categoryId: data.categoryId.value,
        materialName: data.materialName.value,
        standardUsefulLife: data.standardUsefulLife.value,
        targetUsefulLife: data.targetUsefulLife.value,
        displayOrder: data.displayOrder.value,
      };

      const res = await UseFulLifeApi.updateUsefulLifeMaster(body);
      showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, async () => {
        handleAfterAddEdit(res && res.data ? res.data : "");
      });
    } catch (error) {
      handleCatchError(error);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = () => {
    if (!validate()) return;
    showConfirmMessage(
      mode === MODE_SCREEN.ADD
        ? COMMON_CONSTANT.BOM_C008
        : COMMON_CONSTANT.BOM_C009,
      onSaveData
    );
  };

  // GET DETAIL BY ID
  const getDetailById = async (id) => {
    try {
      setLoading(true);

      const res = await UseFulLifeApi.getUsefulLifeMasterById(id);
      if (res && res.data) {
        setDataDetail(res.data);
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  };
  const onSelectList = useCallback((node, isFetching) => {
    if (mode !== MODE_SCREEN.VIEW && !isFetching) {
      return;
    }
    setCurrentNode(node);
    setMode(MODE_SCREEN.VIEW);
    getDetailById(node ? node.id : "");
    setFirstNodeFilter(null);
  }, [mode]);

  const setDataDetail = (dataDetail) => {
    if (dataDetail) {
      const dataCopy = { ...data };
      dataCopy.equipmentCategoryCode.value = dataDetail.equipmentCode;
      dataCopy.equipmentCategoryName.value = dataDetail.equipmentName;
      dataCopy.mainCategoryCode.value = dataDetail.equipmentHigherCode;
      dataCopy.mainCategoryName.value = dataDetail.equipmentHigher;
      dataCopy.subCategoryCode.value = dataDetail.equipmentMiddleCode;
      dataCopy.subCategoryName.value = dataDetail.equipmentMiddle;
      dataCopy.smallCategoryCode.value = dataDetail.equipmentMinorCode;
      dataCopy.smallCategoryName.value = dataDetail.equipmentMinor;
      dataCopy.materialName.value = dataDetail.materialName;
      dataCopy.standardUsefulLife.value = dataDetail.standardUsefulLife;
      dataCopy.targetUsefulLife.value = dataDetail.targetUsefulLife;
      dataCopy.displayOrder.value = dataDetail.displayOrder;
      dataCopy.id.value = dataDetail.id;
      dataCopy.categoryId.value = dataDetail.categoryId;
      setData(dataCopy);
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  // GET LIST
  const getListUseFulLife = async (categoryID, idFocus) => {
    try {
      setLoading(true);
      const res = await UseFulLifeApi.getList({
        type: categoryID,
      });
      if (res && res.data) {
        const data = res.data || [];
        setDataSource({
          ...dataSource,
          data,
          count: data.length,
          idFocus: idFocus,
        });
        return data;
      }
      return null;
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  };

  // GET KBN
  const getKBNCate = async () => {
    try {
      const res = await kbn.getCategoryMachine2();
      if (statusRes(res)) {
        const data = res.data.data || [];
        const firstCate = "";
        setDataSearch({
          ...dataSearch,
          equipmentCategory: {
            ...dataSearch.equipmentCategory,
            options: data,
            value: firstCate,
          },
        });
        getListUseFulLife(firstCate);
      } else {
        throw new Error();
      }
    } catch (error) {
      handleCatchError(error);
    }
  };
  useEffect(() => {
    getKBNCate();
  }, []);

  // CHANGE SELECT SEARCH
  const onChangeCate = useCallback((cate) => {
    resetData();
    getListUseFulLife(cate);
  },[])
  // Focus First Node filter
  useEffect(() => {
    if (firstNodeFilter && mode === MODE_SCREEN.VIEW) {
      onSelectList(firstNodeFilter);
    } else if (firstNodeFilter === undefined) {
      setCurrentNode(null);
      setData(originDataInstance());
    }
  }, [firstNodeFilter]);

  //
  const divRef = useRef(null);
  useEffect(() => {
    if (divRef.current) {
      const width = divRef.current.getBoundingClientRect().width;
      dispatch(
        setWidthModalColTable({
          key: "useful",
          value: width,
        })
      );
    }
  }, [collapsed, triggerWidth]);

  useEffect(() => {
    const handleResize = () => {
      setMaxSize(collapsed ? window.innerWidth - 200 : window.innerWidth - 300);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setMaxSize(collapsed ? window.innerWidth - 200 : window.innerWidth - 300);
  }, [collapsed]);

   useEffect(() => {
      if (mode === MODE_SCREEN.EDIT && editData) {
        let isChange = false;
        Object.keys(editData).forEach((key) => {
          if (editData[key].value != data[key].value) {
            isChange = true;
          }
        });
        setDisabledEdit(!isChange);
      }
    }, [mode, editData, data]);

  // CHeck NO DATA
  const isNodata =
    !data ||
    (data &&
      isEmptyData(data.materialName.value) &&
      isEmptyData(data.standardUsefulLife.value) &&
      isEmptyData( data.targetUsefulLife.value))


  return (
    <div className="des-content">
      <TitlePage name="耐用年数マスタ" />
      <div style={{ marginTop: 16 }}>
        <Overlay top={-28} />
        <SplitComponent
          onDragFinished={() => setTriggerWidth(!triggerWidth)}
          split="vertical"
          defaultSize="60%"
          minSize={40}
          maxSize={maxSize}
        >
          <div
            className="equipment-tree-detail"
            style={{ paddingRight: 8, overflow: "hidden" }}
            ref={divRef}
          >
            <ListUsefulLifeMaster
              currentNode={currentNode}
              setCurrentNode={onSelectList}
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              dataSource={dataSource}
              onChangeCate={onChangeCate}
              mode={mode}
              setFirstNodeFilter={setFirstNodeFilter}
            />
          </div>
          <div
            className="equipment-tree-detail"
            style={{ padding: 8, background: "#fff", height: "100%" }}
          >
            <ViewUsefulLifeMaster
              usefulLifeData={data}
              setUsefulLifeData={setData}
              currentNode={currentNode}
              mode={mode}
              inputRefs={inputRefs}
              setIsFillData={setIsFillData}
            />
          </div>
        </SplitComponent>
      </div>

      <FooterPage>
        {mode === MODE_SCREEN.VIEW ? (
          <Row justify="end">
            <Col>
              <Button
                disabled={!currentNode}
                onClick={handleEdit}
                className="buttonPC button--outline wAuto ml15"
              >
                <EditOutlined /> {lang.EDIT}
              </Button>
            </Col>
            <Col>
              <Button
                onClick={showMessageDeleteConfirm}
                disabled={!currentNode || isNodata || !isLead}
                className={`buttonPC ${
                  currentNode && !isNodata && isLead ? " button--error--outline" : "button--outline"
                } ml15`}
              >
                <DeleteOutlined /> {lang.DELETE}
              </Button>
            </Col>
          </Row>
        ) : (
          <Row justify="end">
            <Col>
              <Button
                disabled={mode == MODE_SCREEN.EDIT && disabledEdit}
                onClick={handleSave}
                className="buttonPC button--info wAuto ml10"
              >
                <SaveOutlined /> {lang.SAVE}
              </Button>
            </Col>
            <Col>
              <Button
                onClick={handleCancel}
                className="buttonPC button--outline wAuto ml15"
              >
                <CloseCircleOutlined /> {lang.CANCEL}
              </Button>
            </Col>
          </Row>
        )}
      </FooterPage>
      <Loading show={loading} />
    </div>
  );
};

export default UsefulLifeMaster;
